(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .config(paginationConfig);

    // inca$ - aggiunto per evitare l'errore 
    // Error: [$injector:strictdi] paginationConfig is not using explicit annotation and cannot be invoked in strict mode
    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();
